<template>
  <div class="antd_breadcrumb">
    <a-breadcrumb v-bind="$attrs" :separator="separator">
      <a-breadcrumb-item v-for="(item,index) in data" :key="index" v-bind="item" @click.native="() => $listeners.click(item)" :class="`antd_breadcrumb_item ${(select === item.value) && 'active'}`">
        <i :class="`iconfont ${item.icon}`" />
        <span :style="{...item.style,...((select === item.value) ? item.activeStyle : {})}" v-html="item.label"></span>
      </a-breadcrumb-item>
    </a-breadcrumb>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Array, default: () => [] },
    select: { type: String, default: null },
    separator: { type: String, default: ">" },
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>